const AbstractRepository = require('@/lib/Repositories/AbstractRepository');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const Image = require('./Image');
const ImageKeyEnum = require('@/lib/Images/ImageKeyEnum');

/**
 * Some images, such as a company logo, are stored in IndexedDB are base64 encoded strings.
 * These images are not synced on their own - they come as part of the user response when logging in
 * or refreshing the current user.
 */
class ImageRepository extends AbstractRepository {
    /**
     * @param {DataStore} dataStore
     * @param {Hydrator} hydrator
     * @param {SyncStateManager} syncStateManager
     */
    constructor(
        dataStore,
        hydrator,
        syncStateManager,
    ) {
        super(dataStore, hydrator, syncStateManager);

        this.keysAreIntegers = false;
    }

    getEntityClass() {
        return Image;
    }

    getEntityName() {
        return 'Image';
    }

    getTableName() {
        return DataStoreNames.IMAGES;
    }

    /**
     * We should only have data for one company in IndexedDB. So there should either be
     * 1 or 0 logos with this key.
     *
     * @return {Promise<Image>}
     */
    getCompanyPrintableLogo() {
        // We should only have data for one
        return this.find(ImageKeyEnum.COMPANY_PRINTABLE_LOGO);
    }

    /**
     * @param {string} data
     *
     * @return {Promise}
     */
    storeCompanyPrintableLogo(data) {
        const image = new Image({
            key: ImageKeyEnum.COMPANY_PRINTABLE_LOGO,
            data,
        });
        return this.persist(image);
    }

    /**
     * @param {number} branchID
     *
     * @return {Promise<Image>}
     */
    getBranchPrintableLogo(branchID) {
        const key = `${ImageKeyEnum.BRANCH_PRINTABLE_LOGO}--${branchID}`;
        return this.find(key);
    }

    /**
     * @param {number} branchID
     * @param {string} data
     *
     * @return {Promise}
     */
    storeBranchPrintableLogo(branchID, data) {
        const key = `${ImageKeyEnum.BRANCH_PRINTABLE_LOGO}--${branchID}`;
        const image = new Image({
            key,
            data,
        });
        return this.persist(image);
    }
}

module.exports = ImageRepository;
